module.exports = __webpack_public_path__ + "img/rejected.77f286b4.svg";